import React, { useContext, useEffect, useState } from "react";
import styles from "./PosterGenerated.module.css";
import downloadIcon from "../assests/posterCreation/downloadIcon.svg";
import { useLocation, useNavigate, useParams } from "react-router";
import facebook from "../assests/share/fbLogo.svg";
import whatsapp from "../assests/share/whatsApp.svg";
import twitter from "../assests/posterCreation/twitterX.svg";
import email from "../assests/share/email.svg";
import copyLinkIcon from "../assests/posterCreation/copyLinkIcon.svg";
import Context from "../context/Context";
import { createSearchParams } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import axios from "axios";
import homeButton from "../assests/posterCreation/homeButton.svg";
import user from "../assests/user.svg";
import toContestIcon from "../assests/posterCreation/toContestIcon.svg";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";

function PosterGenerated() {
  const { occasion, uniqueId } = useParams();
  const [copied, setCopied] = useState(false);
  const {
    ocassionDataofEvent,
    preview,
    userIdToken,
    setPinData,
    setValidationComplete,
    setGeneratedPosterUrl,
    loadHomePageDetails,
    details,
  } = useContext(Context);
  const { currentUser, searchParams, setPreviousLocation } = useUserAuth();
  const [participateLoading, setParticipateLoading] = useState(false);
  const [multipleEntryPopup, setMultipleEntryPopup] = useState(false);
  const [showVoucher, setshowVoucher] = useState(false);
  const [participate, setParticipate] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  let orgDomain = ocassionDataofEvent?.orgDomain;
  let campaignUniqueText = ocassionDataofEvent?.campaignUniqueText;
  let contestUniqueText = ocassionDataofEvent?.contestUniqueText;

  // let generatedImageName = "v1_poster_" + uniqueId + ".jpg"
  let generatedImageName = uniqueId;
  let generatedPosterUrl = `https://storage.googleapis.com/goviral_posters/${occasion}/${generatedImageName}.jpg`;
  setGeneratedPosterUrl(generatedPosterUrl);
  let shareUrl = `https://share.goviralit.com/posb${occasion}fn${generatedImageName}`;
  const token = userIdToken || currentUser?.accessToken;

  const downloadImage = (e) => {
    fetch(generatedPosterUrl, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "image.jpeg"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const whatsapplink = () => {
    window.open("whatsapp://send?text= " + shareUrl);
  };
  const facebooklink = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
    return false;
  };
  const shareToTwitter = () => {
    window.open(`http://twitter.com/share?url=${shareUrl}`);
  };
  const shareToEmail = () => {
    window.location.href = `mailto:?body=${shareUrl}`;
  };

  function shareLink() {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, [1000]);
    navigator.clipboard.writeText(shareUrl);
    window.document.execCommand("copy");
    // alert(shareUrl + "\n copied to clipboard")
  }
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/signup`,
          search: "?preview=true",
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    }
  };

  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/profile`,
          search: "?preview=true",
        },
        { state: { previousLocation: location?.pathname } }
      );
    } else {
      navigate(
        {
          pathname: `/profile`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        { state: { previousLocation: location?.pathname } }
      );
    }
  };
  const handleParticipate = async () => {
    try {
      setParticipateLoading(true);
      await loadHomePageDetails(orgDomain, campaignUniqueText);
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_VALIDATE_UPLOAD}/${ocassionDataofEvent?.orgId}/${ocassionDataofEvent?.campaignId}/${ocassionDataofEvent?.contestId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);

      if (response.data.data.multipleEntriesFound) {
        setParticipateLoading(false);
        setMultipleEntryPopup(true);
        setshowVoucher(false);
        setParticipate(false);
      } else if (response.data.data.validationCompleted) {
        setValidationComplete(true);
        setParticipateLoading(false);

        navigate({
          pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else {
        if (response.data.data.isVoucherValid && response.status === 201) {
          setPinData(response);
          setParticipateLoading(false);

          navigate({
            pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        } else if (!response.data.data.isVoucherValid) {
          setParticipateLoading(false);

          navigate({
            pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate/error`,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        }
      }
    } catch (error) {
      setParticipateLoading(false);
      navigate({
        pathname: `/${orgDomain}/${campaignUniqueText}/${contestUniqueText}/participate/error`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  return (
    <>
      <FloatingWidgets
        page="campaign"
        prize={details?.priceDescription}
        endTime={details?.endDate}
        color={details?.btnColor}
        bgColor={details?.bgColor}
      />
      <div className={styles.posterGeneratedContainer}>
        <div className="flex px-[20px] mt-[20px] mb-[20px] items-center justify-between w-full">
          <a href={`/poster/${occasion}`}>
            {/* <img
                        className='cursor-pointer'
                        src={backIcon} alt=""
                    // onClick={() => {
                    //     navigate(`/poster/${occasion}`)
                    // }}
                    /> */}
            {/* <p className="text-black text-[13px] underline opacity-0.7">Home</p> */}
            <img src={homeButton} alt="" />
          </a>
          <div>
            {currentUser ? (
              <>
                <img
                  src={currentUser?.photoURL ? currentUser?.photoURL : user}
                  alt=""
                  className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                  onClick={handleProfileNavigate}
                />
              </>
            ) : (
              <img
                src={user}
                alt=""
                className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                onClick={handleLogin}
              />
            )}
          </div>
        </div>
        {/* {ocassionDataofEvent?.participateInContest && (
                <div
                    className="px-[20px] py-[16px] bg-[#FFF1BF]">
                    <button className="flex gap-[11px] items-center text-left "
                        onClick={handleParticipate}
                        disabled={participateLoading}>
                        <p
                            className="text-black text-[16px] leading-[22px] font-semibold">
                            Share this image with {ocassionDataofEvent?.title} & win exciting gifts</p>
                        <img
                            src={toContestIcon} alt="" />
                    </button>
                </div>)
            } */}
        {ocassionDataofEvent?.participateInContest && (
          <div className={styles.contestCard}>
            <button
              className="flex gap-[12px] items-center text-left"
              onClick={handleParticipate}
              disabled={participateLoading}
            >
              <img
                src={ocassionDataofEvent?.posterUrl}
                className="w-[79px] h-[89px] object-cover "
              />
              <div>
                <p className={styles.contestCardName}>
                  {ocassionDataofEvent?.title}
                </p>
                <p className="text-smallest text_Ell my-[8px] text-black ">
                  {ocassionDataofEvent?.description}
                  {/* Participate in the Aarrpoy! Onam 2023 using this generated poster. */}
                </p>
                {/* <p className="text-[#0F6ABE] text-smallest mt-[5px]">
                                {" "}
                                Participate {">"}
                            </p> */}
                <button className={` ${styles.button}`}>
                  {participateLoading ? "Loading..." : "Participate"}
                </button>
              </div>
            </button>
          </div>
        )}
        <div className="w-full flex flex-col items-center mt-[20px]">
          <div className="mt-[14px] mb-[24px] px-[24px]">
            <img
              src={generatedPosterUrl}
              alt=""
              // className=" object-cover aspect-square rounded-[16px] shadow-[0px 0px 32px 0px rgba(0, 0, 0, 0.20)]"
              className=" object-cover w-[240px] rounded-[16px] shadow-[0px 0px 32px 0px rgba(0, 0, 0, 0.20)]"
            />
          </div>
          {/* <p className='text-black text-[14px] mb-[8px] px-[24px] text-center font-medium'>I enjoyed Aqua Fantasy in Underwater tunnel aquarium</p> */}
          {/* <div className="w-full mb-[16px] px-[40px]">
                    <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
                </div> */}
          {/* <p className="text-black text-[18px] font-semibold leading-[24px] mb-[15px]">
                    How to participate?
                </p>
                <div className="text-black text-[16px] leading-[22px] px-[20px] mb-[15px] w-full">
                    <div className="w-full">
                        <div className="flex gap-[5px] w-full mb-[12px] ">
                            <p>*</p>
                            <p>Get your poster downloaded and participate in the contest at the following link: <span className={styles.participateLink}>{ocassionDataofEvent?.contestLink}</span>  </p>
                        </div>
                        <div className="flex gap-[5px]">
                            <p>*</p>
                            <p>Click on the above contest banner and participate in the contest.</p>
                        </div>
                    </div>
                </div>
                <div className="w-full mb-[16px] px-[40px]">
                    <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
                </div> */}
          <p className="text-black text-[18px] font-semibold leading-[24px] mb-[15px]">
            Share with friends
          </p>
          <div className=" px-[42px] w-full flex justify-between mb-[16px] ">
            <div
              onClick={downloadImage}
              className="flex flex-col gap-[6px] items-center cursor-pointer"
            >
              <img src={downloadIcon} alt="" />
              <p className="text-[13px] text-black leading-[18px]">Download</p>
              {/* {sharestate ? <></> : <img
                        className='cursor-pointer'
                        src={shareIcon} alt=""
                        onClick={() => {
                            setShareState(true)
                        }} />} */}
            </div>
            <div
              onClick={facebooklink}
              className="flex flex-col gap-[6px] items-center cursor-pointer"
            >
              <img src={facebook} alt="" className="w-[36px] h-[36px]" />
              <p className="text-[13px] text-black leading-[18px]">Facebook</p>
            </div>
            <div
              onClick={whatsapplink}
              className="flex flex-col gap-[6px] items-center cursor-pointer"
            >
              <img src={whatsapp} alt="" className="w-[36px] h-[36px]" />
              <p className="text-[13px] text-black leading-[18px]">Whatsapp</p>
            </div>
            <div
              onClick={shareToTwitter}
              className="flex flex-col gap-[6px] items-center cursor-pointer"
            >
              <img src={twitter} alt="" className="w-[36px] h-[36px]" />
              <p className="text-[13px] text-black leading-[18px]">
                X(twitter)
              </p>
            </div>
            <div
              onClick={shareToEmail}
              className="flex flex-col gap-[6px] items-center cursor-pointer"
            >
              <img src={email} alt="" className="w-[36px] h-[36px]" />
              <p className="text-[13px] text-black leading-[18px]">Gmail</p>
            </div>
          </div>
          <div className="w-full mb-[16px] px-[40px]">
            <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
          </div>
          <div className="px-[42px] gap-[8px] mb-[34px]">
            <p className="text-[16px] leading-[22px] text-black ">
              Copy the link
            </p>
            <div className="flex gap-[30px] items-center">
              <p className={styles.copyLink} onClick={shareLink}>
                {shareUrl}
              </p>
              {copied ? (
                <p className="text-black text-[11px] leading-[17px]">Copied</p>
              ) : (
                <img
                  className="cursor-pointer"
                  onClick={shareLink}
                  src={copyLinkIcon}
                  alt=""
                />
              )}
            </div>
          </div>
          <div className="w-full mb-[32px] px-[40px]">
            <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
          </div>
          {ocassionDataofEvent?.contests && (
            <p className="text-black text-[18px] leading-[24px] font-semibold mb-[17px]">
              Similar contest
            </p>
          )}
          {/* {ocassionDataofEvent?.participateInContest && (
                    <button
                        className={`mb-[16px] ${styles.button}`}
                        onClick={handleParticipate}
                        disabled={participateLoading}
                    >
                        Participate
                    </button>
                )} */}

          <div className="flex flex-col gap-[16px] pb-[24px] px-[20px]">
            {ocassionDataofEvent?.contests?.map((obj, i) => {
              return (
                <a
                  href={obj?.contestLink}
                  target="_blank"
                  className="flex gap-[12px] items-center text-left bg-[#FFF1BF] p-[10px] rounded-[8px]"
                >
                  <img
                    src={obj?.poster}
                    className="w-[79px] h-[89px] object-cover rounded-[8px] "
                  />
                  <div>
                    <p className={styles.contestCardName}>{obj?.contestName}</p>
                    <p className="text-smallest text_Ell my-[8px] text-black ">
                      {obj?.contestDescription}
                      {/* Participate in the Aarrpoy! Onam 2023 using this generated poster. */}
                    </p>
                    <p className="text-[#0F6ABE] text-smallest mt-[5px]">
                      {" "}
                      View Detials {">"}
                    </p>
                  </div>
                </a>
              );
            })}
          </div>

          {/* <a
          href="https://share.goviralit.com/pro104ent148inf1106"
          target="_blank"
          className="mb-[24px]"
        >
          <div className="px-[16px] relative">
            <img
              src="https://storage.googleapis.com/goviralcampaignmedias/104/274/campaignPoster/1690453145264"
              alt=""
              className="rounded-[16px] "
            />
            <button className={styles.contestButtonChandrayan}>
              View contest
            </button>
          </div>
        </a> */}

          {/* <a
          href="https://share.goviralit.com/pro104ent153inf1106"
          target="_blank"
          className="mb-[24px]"
        >
          <div className="px-[16px] relative">
            <img
              src="https://storage.googleapis.com/goviralcampaignmedias/104/275/campaignPoster/1691557993055"
              alt=""
              className="rounded-[16px] "
            />
            <button className={styles.contestButtonOnam}>View contest</button>
          </div>
        </a> */}

          <div className="w-full mb-[32px] px-[40px]">
            <div className=" h-[1px] bg-[#161616] opacity-[0.1] "></div>
          </div>
          {ocassionDataofEvent?.examplePosters && (
            <p className="text-black text-[18px] leading-[24px] font-semibold mb-[17px]">
              Generated poster examples
            </p>
          )}
          <div className="grid grid-cols-2 gap-[16px] pb-[24px] px-[20px]">
            {ocassionDataofEvent?.examplePosters?.map((obj, i) => {
              return (
                <div key={i} className="aspect-square">
                  <img
                    src={obj}
                    alt=""
                    className="rounded-[16px] object-cover  h-full w-full   "
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
    // <div className='w-full h-full mt-[50px] mb-[24px] px-[16px] flex justify-center items-center '>
    //     {/* <div className={styles.posterGeneratedbgContainer}
    //         style={{ background: `url(${generatedPosterUrl}) center center / cover` }}> */}
    //     <div className={styles.posterGeneratedbgContainer}>
    //         <img src={generatedPosterUrl}
    //             alt=""
    //             className='object-cover w-full h-full top-0 left-0 absolute rounded-[16px]' />
    //     </div>
    // </div>
  );
}

export default PosterGenerated;
